import React from 'react';
import styled from 'styled-components';
import { getDevice } from '@panel/commons/helpers';

const CommonFormWrapper = ({ children }) => {
  return <Container device={getDevice()}>{children}</Container>;
};

const Container = styled.div`
  padding: ${({ device }) => (device === 'mobile' ? '0px 16px 24px' : '0px 24px 36px')};
`;

export default CommonFormWrapper;
